import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const attachmentListItemStyle = css`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  padding: ${theme.spacing(0, 1)};

  &:not(:last-of-type) {
    border-bottom: 1px dotted ${theme.colors.neutral20};
    margin-bottom: ${theme.spacing(1)};
    padding-bottom: ${theme.spacing(1)};
  }
`;

export const attachmentIconAndNameContainerStyle = css`
  min-width: 0;
  display: flex;
  flex: 1;
  cursor: pointer;
`;

export const attachmentIconStyle = css`
  color: ${theme.colors.text.subdued};
`;

export const attachmentNameStyle = css`
  margin: ${theme.spacing(0, 1.75)};
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const downloadIconButtonStyle = css`
  &:hover:not(:disabled) {
    svg {
      path {
        fill: ${theme.colors.primary50};
      }
    }
  }
`;
